export default "__VITE_ASSET__8237eb62__"